import Model from './model';

export default Model.extend( {} );


// WEBPACK FOOTER //
// ./src/js/model/layer.js